import { BaseStore } from 'fluxible/addons';

export default class ActiveUserFlagStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.flags = {};
    }

    initFromActiveUser(activeUser) {
        if (activeUser && activeUser.flags) {
            this.init(activeUser.flags);
        }
    }

    init(flags) {
        flags.forEach(key => {
            this.flags[key] = true;
        });
    }

    has(flag) {
        return Boolean(this.flags[flag]);
    }

    set({ flag }) {
        this.flags[flag] = true;
        this.emitChange();
    }
}

ActiveUserFlagStore.storeName = 'ActiveUserFlagStore';
ActiveUserFlagStore.handlers = {
    ACTIVE_USER_FLAG_INIT: 'init',
    ACTIVE_USER_FLAG_SET: 'set',
};



// WEBPACK FOOTER //
// ./src/web/js/contest/stores/active-user-flag-store.js